import store from '../../store'
import {assignSpeakerRequest} from '../../actions/recording'
import {bumpTranscriptSpeakerVersion} from '../../prosemirror/transcripts/utils/bumpTranscriptSpeakerVersion'

export function assignSpeaker(recording,speaker,userId,contactId) {	
	store.dispatch(assignSpeakerRequest(recording.recording_id,speaker.speaker_id,userId,contactId))
	bumpTranscriptSpeakerVersion()
}

